<h1 mat-dialog-title>{{ title }}</h1>
<div mat-dialog-content *ngIf='isHtmlContent' [innerHTML]='content'>
</div>
<div mat-dialog-content *ngIf='!isHtmlContent'>
    {{ content }}
</div>
<div mat-dialog-actions >
    <button mat-flat-button mat-dialog-close>{{ rejectButton }}</button>
    <button mat-raised-button color='primary' [mat-dialog-close]="true" cdkFocusInitial>{{ acceptButton }}</button>
</div>
